<template>
    <div style="display: flex;background-color: white;height: 100%;">
        <div class="left-tree">
            <a-page-header title="组织结构" />
            <a-input-search v-model:value="searchTreeValue" style="margin-bottom: 8px" placeholder="Search" />
            <a-tree v-model:selectedKeys="selectedKeys" v-model:fieldNames="fieldName" :tree-data="treeData">
                <template #title="{ name }">
                    <span v-if="name.indexOf(searchTreeValue) > -1">
                        {{ name.substring(0, name.indexOf(searchTreeValue)) }}
                        <span style="color: #f50">{{ searchTreeValue }}</span>
                        {{ name.substring(name.indexOf(searchTreeValue) + searchTreeValue.length) }}
                    </span>
                    <span v-else>{{ name }}</span>
                </template>

            </a-tree>
        </div>

        <div class="my-custom-table">
            <a-page-header title="用户列表" />
            <div class="search-bar">
                <div class="tabInput">
                    <a>用户名称：</a>
                    <a-input v-model:value="username" placeholder="请输入用户名称进行搜索" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch"
                            :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                    <div class="right-option">
                        <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                        <!-- 添加数据 -->
                        <addComponent ref="addChildOpen" />
                    </div>
                </div>
            </div>
            <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id">
                <template #bodyCell="{ column, text, record }">
                    <!-- 渲染颜色 -->
                    <template v-if="column.key === 'username'">
                        <a>
                            {{ record.username }}
                        </a>
                    </template>
                    <template v-if="column.key === 'status'">
                        <span>
                            <a-tag color="green" v-if="text === '正常'">
                                {{ record.status }}
                            </a-tag>
                            <a-tag color="orange" v-else>
                                {{ record.status }}
                            </a-tag>
                        </span>
                    </template>

                    <template v-else>
                        <span v-if="column.key != 'username' && column.key != 'status'">
                            {{ text }}
                        </span>
                    </template>

                    <!-- 渲染操作按钮 -->
                    <template v-if="column.dataIndex === 'operation'">
                        <div class="editable-row-operations">
                            <span v-if="record.permissionName != '超级管理员'">
                                <a-popconfirm title="确定重置当前用户密码？" ok-text="Yes" cancel-text="No"
                                    @confirm="confirmRestPas(record.id)">
                                    <a style="margin: 10px;">重置密码</a>
                                </a-popconfirm>
                                <a style="margin: 10px;" @click="editUser(record)">编辑</a>
                                <!-- 添加数据 -->
                                <editComponent ref="editChildOpen" />
                                <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                    <a style="margin: 10px;">删除</a>
                                </a-popconfirm>
                            </span>
                        </div>
                    </template>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
import { userPage, removeUser, treeDepts, resetPasswordUser } from '@/api/service';
import { cloneDeep } from 'lodash-es';
import { message } from 'ant-design-vue';
import { SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { ref, h, watch } from 'vue';
import addComponent from './modal/addComponent.vue'; // 导入组件
import editComponent from './modal/editComponent.vue'; // 导入组件
export default {
    name: 'UserPage',
    components: {
        addComponent,
        editComponent
    },
    setup() {
        const data = ref([]); // 初始化为空数组
        const username = ref('');//查询条件
        const deptId = ref('')//查询条件
        const addChildOpen = ref(null);//子页面实例
        const editChildOpen = ref(null);//子页面实例
        const searchTreeValue = ref(''); // 树形结构查询条件
        const treeData = ref([]);//树形结构
        const selectedKeys = ref([]);//选中节点
        const fieldName = { children: 'children', title: 'name', key: 'id' };
        const pagination = ref({
            current: 1, // 当前页数
            pageSize: 10, // 每页显示条数
            total: 0, // 数据总数
            showSizeChanger: true, // 是否显示修改每页条数
            showQuickJumper: true, // 是否显示快速跳转
            onChange: (page, pageSize) => {
                pagination.value.current = page;
                pagination.value.pageSize = pageSize;
                list(); // 当分页改变时，重新获取数据
            },
            position: ['bottomLeft']//显示位置
        });
        //列表
        const columns = [
            { title: '用户名', dataIndex: 'username', key: 'username', width: '10%', },
            { title: '部门名称', dataIndex: 'deptName', key: 'deptName', width: '10%', },
            { title: '权限名称', dataIndex: 'permissionName', key: 'permissionName', width: '10%', },
            { title: '状态', dataIndex: 'status', key: 'status', width: '10%', },
            { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: '10%', },
            { title: '操作', dataIndex: 'operation', width: '10%', },
        ];
        //查询数据
        const list = async () => {
            const response = await userPage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                username: username.value,
                deptId: deptId.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0; // 更新 total
                data.value = response.data.records.map(item => ({
                    id: item.id,
                    username: item.username,
                    deptName: item.deptName,
                    permissionName: item.permissionName,
                    deptId: item.deptId,
                    permissionsId: item.permissionsId,
                    status: item.status,
                    createdAt: item.createdAt,
                }));
            }
        };
        //查询树形结构
        const tree = async () => {
            const response = await treeDepts({});
            if (response.code === 200) {
                treeData.value = response.data.records;
            }
        };
        //树形结构选择
        watch(selectedKeys, () => {
            console.log(selectedKeys.value);
            deptId.value = selectedKeys.value.at(0) === undefined ? '' : selectedKeys.value.at(0);
            list();
        });
        tree();
        // 组件初始化时调用一次
        list();
        //删除菜单
        const deleteUser = async (data) => {
            const response = await removeUser(data);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };
        //删除
        const remove = id => {
            if (deleteUser(id)) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };
        //重置密码
        const rest = async (data) => {
            const response = await resetPasswordUser(data);
            if (response.code === 200) {
                message.success('重置成功');
                return true;
            } else {
                message.error('重置失败' + response.msg);
                return false;
            }
        };
        const confirmRestPas = e => {
            console.log(e);
            rest({ 'id': e });
        };
        //搜索
        const onSearch = () => {
            pagination.value.current = 1; // 搜索时重置当前页数
            list();
        }
        //重置
        const onReset = () => {
            username.value = ''; // 重置搜索关键词
            deptId.value = ''; // 重置部门
            list(); // 重置后重新获取数据
        }
        //添加
        const toAdd = () => {
            addChildOpen.value.open = true;
        }
        //修改用户
        const editUser = (record) => {
            editChildOpen.value.open = true;
            editChildOpen.value.pushData =  record;
            console.log(record);
        }
        return {
            columns,
            pagination,
            data,
            deleteUser,
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            onSearch,
            onReset,
            addComponent,
            editComponent,
            treeData,
            toAdd,
            addChildOpen,
            editChildOpen,
            ref,
            h,
            remove,
            username,
            list,
            searchTreeValue,
            fieldName,
            treeDepts,
            confirmRestPas,
            selectedKeys,
            watch,
            editUser
        };
    },
};
</script>
<style>
.tabInput {
    margin-left: 10px;
    width: 20%;
}
</style>